import { useRef, useState } from "react";
import ManageReviewsContainer from "./container"
import { useGetFeedbackQuery } from "./service";
import dayjs from "dayjs";

const ratingsOptions = [
    { value: "all", label: "All Ratings" },
    { value: "5", label: "5 stars" },
    { value: "4", label: "4 stars" },
    { value: "3", label: "3 stars" },
    { value: "2", label: "2 stars" },
    { value: "1", label: "1 stars" },
];

const statusOptions = [
    { value: "all", label: "All Status" },
    { value: "replied", label: "Replied" },
    { value: "unreplied", label: "Unreplied" },
    { value: "reported", label: "Reported" },
]

const ManageReviews = () => {

    const [reviewDetailsModal, setReviewDetailsModal] = useState(false);
    const [reviewReportModal, setReviewReportModal] = useState(false);

    const [reviewData, setReviewData] = useState({});
    const [search, setSearch] = useState("");
    const [ratings, setRatings] = useState("all");
    const [status, setStatus] = useState("all");

    // Reset to page 1 when any filter changes
    const handleSetSearch = (value) => {
        setSearch(value);
        setPaginationModel((prev) => ({ ...prev, page: 0 }));
    };

    const handleSetRatings = (value) => {
        setRatings(value);
        setPaginationModel((prev) => ({ ...prev, page: 0 }));
    };

    const handleSetStatus = (value) => {
        setStatus(value);
        setPaginationModel((prev) => ({ ...prev, page: 0 }));
    };

    const [openFrom, setOpenFrom] = useState(false);
    const [openTo, setOpenTo] = useState(false);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    const fromAnchorRef = useRef(null);
    const toAnchorRef = useRef(null);

    const [appliedFromDate, setAppliedFromDate] = useState("");
    const [appliedToDate, setAppliedToDate] = useState("");

    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10
    });

    const { data: feedbackdata, isFetching, isLoading } = useGetFeedbackQuery({
        search,
        ratings: ratings === "all" ? "" : ratings,
        status: status === "all" ? "" : status,
        fromDate: appliedFromDate,
        toDate: appliedToDate,
        page: paginationModel.page + 1,        // assuming backend pages are 1-based
        limit: paginationModel.pageSize,
    });

    const handleReviewDetailsModal = (value) => {
        setReviewDetailsModal(true);
        setReviewData(value)
    }

    const handleReviewReportModal = (e, value) => {
        e.stopPropagation();
        setReviewReportModal(true);
        setReviewData(value)
    }

    const handleApplyFilter = () => {
        // if (fromDate && toDate) {
        //     if (dayjs(fromDate).isAfter(dayjs(toDate))) {
        //         setDateError(
        //             "From date cannot be greater than To date"
        //         );
        //         return;
        //     }
        // }

        // setDateError("");

        /* Pass to API */
        setAppliedFromDate(fromDate ? dayjs(fromDate).format("YYYY-MM-DD") : "");
        setAppliedToDate(toDate ? dayjs(toDate).format("YYYY-MM-DD") : "");
    };

    const handleClearFilter = () => {
        setFromDate(null);
        setToDate(null);
        setAppliedFromDate("");
        setAppliedToDate("");
    };

    const totalCount = feedbackdata?.data?.totalCount || 0;

    return (
        <ManageReviewsContainer
            reviewDetailsModal={reviewDetailsModal}
            setReviewDetailsModal={setReviewDetailsModal}
            reviewReportModal={reviewReportModal}
            setReviewReportModal={setReviewReportModal}
            ratingsOptions={ratingsOptions}
            statusOptions={statusOptions}
            feedbackdata={feedbackdata?.data}
            handleReviewDetailsModal={handleReviewDetailsModal}
            handleReviewReportModal={handleReviewReportModal}
            reviewData={reviewData}
            search={search}
            setSearch={handleSetSearch}
            searchLoader={isFetching}
            loading={isLoading}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            rowCount={totalCount}
            ratings={ratings}
            setRatings={handleSetRatings}
            setStatus={handleSetStatus}
            status={status}
            handleClearFilter={handleClearFilter}
            openFrom={openFrom}
            setOpenFrom={setOpenFrom}
            openTo={openTo}
            setOpenTo={setOpenTo}
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            fromAnchorRef={fromAnchorRef}
            toAnchorRef={toAnchorRef}
            handleApplyFilter={handleApplyFilter}
            appliedFromDate={appliedFromDate}
            appliedToDate={appliedToDate}
        />
    )
}

export default ManageReviews;